import { PropertyFilterProperty } from '@amzn/awsui-collection-hooks';
import { TFunc } from 'src/common/types';

export const filteringProperties = (t: TFunc): PropertyFilterProperty[] => [
  {
    propertyLabel: t('methodology'),
    key: 'methodology',
    groupValuesLabel: t('group_value_label', { label: t('methodology') }),
    operators: [':', '!:', '=', '!='],
  },
  {
    propertyLabel: t('business'),
    key: 'business',
    groupValuesLabel: t('group_value_label', { label: t('business') }),
    operators: [':', '!:', '=', '!='],
  },
  {
    propertyLabel: t('last_updated_date'),
    key: 'lastUpdateTimestamp',
    groupValuesLabel: t('group_value_label', { label: t('last_updated_date') }),
    operators: [':', '!:', '=', '!='],
  },
  {
    propertyLabel: t('name'),
    key: 'reportName',
    groupValuesLabel: t('group_value_label', { label: t('name') }),
    operators: [':', '!:', '=', '!='],
  },
];
